import { types } from '../constants'

const index = {
  pending: `${types.get}_PENDING`,
  fulfilled: `${types.get}_FULFILLED`,
  rejected: `${types.get}_REJECTED`
}

export const get = {
  [index.pending]: ({ draft }) => {
    draft.template.item.loading = true
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.template.item.data = action.payload
    draft.template.item.loading = false
  },
  [index.rejected]: ({ draft }) => {
    draft.template.item.loading = false
  }
}
